<template>
  <div
    class="w-full h-10 flex items-center justify-between px-3 grow bg-secondary border-b border-secondary"
  >
    <div class="flex items-center grow overflow-x-auto">
      <Breadcrumb
        :items="breadcrumb"
        :limit="maxTablet ? 0 : 3"
        size="md"
        :isScrollable="maxTablet"
      >
        <template #leading>
          <Indicator
            variant="building"
            size="xs"
            :imageUrl="task.tenant.logo_url"
            mode="transparent"
            class="mr-2"
          />
        </template>
      </Breadcrumb>
    </div>
    <LinkedToSelectModal
      v-if="!readonly"
      :title="$t('components.task_details.location.title')"
      :description="$t('components.task_details.location.description')"
      :initialState="linkedTo"
      :buildingId="task.tenant.id"
      :multiple="false"
      :defaultTab="
        ['asset', 'asset_group'].includes(task.space?.type.value) ? 1 : 0
      "
      @update="handleUpdateSpace"
    >
      <Tooltip
        :title="$t('components.tooltips.relink_task')"
        side="bottom"
        disableHoverableContent
      >
        <IconButton
          variant="tertiary"
          type="gray"
          size="xs"
          data-id="linked-to.edit"
        >
          <Icon name="edit-pen" size="sm" />
        </IconButton>
      </Tooltip>
    </LinkedToSelectModal>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { IconButton } from "@/SharedComponents/Buttons";
import { Breadcrumb } from "@/SharedComponents/Breadcrumbs";
import { Icon } from "@/SharedComponents/Icon";
import { Indicator } from "@/SharedComponents/Indicator";
import { LinkedToSelectModal } from "@/SharedComponents/Modals";
import { Tooltip } from "@/SharedComponents/Tooltips";
import { useTask } from "@/Composables/useTask";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxTablet } = useBreakpoints();
const emit = defineEmits(["update"]);

const props = defineProps({
  task: { type: Object, required: true },
  readonly: { type: Boolean, required: false },
});

const { getBreadcrumb } = useTask(props.task);

const breadcrumb = computed(() => {
  return getBreadcrumb(props.task);
});

const linkedTo = ref({
  buildings: [],
  children: [props.task.space?.id],
});

watch(
  () => props.task.space?.id,
  (value) => {
    linkedTo.value.children = [value];
  },
  { immediate: true }
);

function handleUpdateSpace(space) {
  linkedTo.value.children = space ? [space?.id] : [];
  emit("update", { space_id: space?.id || null });
}
</script>
